module.exports = __webpack_public_path__ + "media/images/icons/attachment-f1d6838a75b54764ac58f74fc7dd0832.svg";